import { createSelector } from 'reselect'; // @ts-expect-error untyped dependency

import { makePermissionComponent } from 'ecosystem-marketplace-core/components/permissions';
import * as AppContext from '../constants/AppContext';

function getAppContext(state) {
  return state.app.appContext;
}

function makeAppContextSelector(appContext) {
  return createSelector([getAppContext], _appContext => {
    return _appContext === appContext;
  });
}

export const getIsInApp = makeAppContextSelector(AppContext.IN_APP);
export const getIsAdminPreviewApp = makeAppContextSelector(AppContext.ADMIN_PREVIEW);
export const getIsPublicApp = makeAppContextSelector(AppContext.PUBLIC);
export const PublicAppContext = makePermissionComponent(getIsPublicApp);